// extracted by mini-css-extract-plugin
module.exports = {"inputButton":"_3_kYgW_W-Oy65tQh","submitButton":"_2wvlFZCMkFnzcRMa","submitIconButton":"_33Csh_d0BxlUm6DL"};